export default class ReadMoreToggler {
    constructor(element) {
        if (!element) return
        this.toggler = element
        this.entryContent = document.querySelector( element.dataset.toggle )
		if (!this.entryContent) return

        this.entryContentHeight = this.entryContent.getBoundingClientRect().height
        this.entryContentMaxHeight = parseInt(this.toggler.dataset.maxHeight)

        this.init()
        this.events()
    }

    onTogglerClick(ev) {
        ev.preventDefault()
        this.toggler.classList.toggle('toggled')

        if (this.toggler.classList.contains('toggled')) {
            this.toggler.getElementsByTagName("span")[0].textContent = this.toggler.dataset.closeText
			this.entryContent.style.height = `${this.entryContentHeight}px`
		} else {
            this.toggler.getElementsByTagName("span")[0].textContent = this.toggler.dataset.openText
			this.entryContent.style.height = `${this.entryContentMaxHeight}px`
		}

        this.entryContent.classList.toggle('toggled')
    }

    init() {
        if( this.entryContentHeight - 30 > this.entryContentMaxHeight) {
            this.entryContent.style.height = `${this.entryContentMaxHeight}px`
            this.entryContent.classList.add('faded')
            this.toggler.classList.remove('d-none')
        }
    }

    events() {
        if( this.entryContentHeight > this.entryContentMaxHeight) {
            this.toggler.addEventListener('click', this.onTogglerClick.bind(this), false )
        }
    }
}
